import axios from "axios";

export const STRAPI_TOKEN = '';
export const BACKEND_URL = 'https://supply.napitkivmeste.ru'

export const getAuthConfig = () => {
  return {
    headers: {
      Authorization: `Bearer ${STRAPI_TOKEN}`,
    },
    withCredentials: true,
  };
};

export const getDataGOS = (modelName: string, params = {}) => {
  return axios.get(`${BACKEND_URL}/api/${modelName}?populate=*`, {
    ...getAuthConfig(),
    params,
  });
};

export const extractStrapiData = (response: any) => {
  if (response && response.data && response.data.data) {
    return response.data.data;
  }
  if (response && response.data) {
    return response.data;
  }
  return [];
};

export const addDataGOS = (modelName: string, data: any) => {
  const formattedData = data.data ? data : { data };
  return axios.post(`${BACKEND_URL}/api/${modelName}`, formattedData, getAuthConfig()).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const updateDataGOS = (modelName: string, documentId: string, data: any) => {
  const formattedData = data.data ? data : { data };
  return axios.put(`${BACKEND_URL}/api/${modelName}/${documentId}`, formattedData, getAuthConfig())
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Ошибка обновления:', error.response?.data || error.message);
      throw error;
    });
};

export const deleteData = (modelName: string, documentId: string) => {
  return axios.delete(`${BACKEND_URL}/api/${modelName}/${documentId}`, getAuthConfig()).catch((error) => {
    console.error('Ошибка API:', error.response?.data || error.message);
    throw error;
  });
};

export const uploadFileToStrapi = (file: File, onProgress?: (progress: number) => void) => {
  const formData = new FormData();
  formData.append('files', file);

  return axios.post(`${BACKEND_URL}/api/upload`, formData, {
    ...getAuthConfig(),
    headers: {
      ...getAuthConfig().headers,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total && onProgress) {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(progress);
      }
    },
  });
};

export const createFileUploadRecord = (fileId: number, prescID: number) => {
  return axios.post(
    `${BACKEND_URL}/api/gos-prescriptions-uploads`,
    {
      data: {
        Name: fileId,
        PrescID: prescID,
      },
    },
    getAuthConfig()
  );
};

export const getFilesForPrescription = (prescID: number) => {
  return axios.get(
    `${BACKEND_URL}/api/gos-prescriptions-uploads?filters[PrescID][$eq]=${prescID}&populate[Name][fields][0]=name&populate[Name][fields][1]=url&populate[Name][fields][2]=size&populate[Name][fields][3]=mime&populate[Name][fields][4]=id`,
    getAuthConfig()
  );
};

export const deleteFileUploadRecord = (documentId: string) => {
  return deleteData('gos-prescriptions-uploads', documentId);
};

export const deleteFileFromStrapi = (uploadId: number) => {
  return axios.delete(`${BACKEND_URL}/api/upload/files/${uploadId}`, getAuthConfig());
};

export const createLicenseFileUploadRecord = (fileId: number, licensesID: number) => {
  return axios.post(
    `${BACKEND_URL}/api/gos-licenses-uploads`,
    {
      data: {
        Name: fileId,
        LicensesID: licensesID,
      },
    },
    getAuthConfig()
  );
};

export const getFilesForLicense = (licensesID: number) => {
  return axios.get(
    `${BACKEND_URL}/api/gos-licenses-uploads?filters[LicensesID][$eq]=${licensesID}&populate[Name][fields][0]=name&populate[Name][fields][1]=url&populate[Name][fields][2]=size&populate[Name][fields][3]=mime&populate[Name][fields][4]=id`,
    getAuthConfig()
  );
};

export const deleteLicenseFileUploadRecord = (documentId: string) => {
  return deleteData('gos-licenses-uploads', documentId);
};

export const fetchSettings = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gos-settings?populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return Array.isArray(data.data) ? data.data : [data.data];
};

export const fetchContacts = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gos-contacts?populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return Array.isArray(data.data) ? data.data : [data.data];
};

export const fetchInstructions = async () => {
  const response = await fetch(`${BACKEND_URL}/api/gos-instructions?populate=*`, {
    headers: {
      'Authorization': `Bearer ${STRAPI_TOKEN}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include'
  });
  const data = await response.json();
  return Array.isArray(data.data) ? data.data : [data.data];
};
